var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F49302"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5C24.8284 16.5 25.5 17.1716 25.5 18V24C25.5 24.8284 24.8284 25.5 24 25.5C23.1716 25.5 22.5 24.8284 22.5 24V18C22.5 17.1716 23.1716 16.5 24 16.5Z",
    fill: "#F49302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.5C24.8284 31.5 25.5 30.8284 25.5 30C25.5 29.1716 24.8284 28.5 24 28.5C23.1716 28.5 22.5 29.1716 22.5 30C22.5 30.8284 23.1716 31.5 24 31.5Z",
    fill: "#F49302"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 24C7.5 14.8873 14.8873 7.5 24 7.5C33.1127 7.5 40.5 14.8873 40.5 24C40.5 33.1127 33.1127 40.5 24 40.5C14.8873 40.5 7.5 33.1127 7.5 24ZM24 10.5C16.5441 10.5 10.5 16.5441 10.5 24C10.5 31.4558 16.5441 37.5 24 37.5C31.4558 37.5 37.5 31.4558 37.5 24C37.5 16.5441 31.4558 10.5 24 10.5Z",
    fill: "#F49302"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ea374ef4.svg";
export { ForwardRef as ReactComponent };